/**
 * Error type thrown by service layer when the backend returns a non-OK
 * response. Carries the HTTP status so callers can distinguish between
 * auth failures (401/403), server errors (5xx) and other errors.
 */
export class ApiError extends Error {
  status?: number;

  constructor(message: string, status?: number) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}